// extracted by mini-css-extract-plugin
export default {"mainDiv":"place_mainDiv__w2+jU","prev":"place_prev__VeZBE","nxt":"place_nxt__zkXcj"};